import { useSelector } from 'react-redux';

import { selectWorkorderInspectionRecommendationOptions } from '../services/selectors';

export const useWorkorderInspectionRecommendationOptions = () =>
    useSelector(selectWorkorderInspectionRecommendationOptions);
